"use client";

export function ScrollSpine() {
  return (
    <>
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main>
            <section>
              <div className="trigger_section">
                <div className="app_section" id="heroTrigger"></div>
                <div className="app_section long" id="workTrigger"></div>
                <div className="app_section" id="cases-in"></div>
                <div className="trigger_wrap" id="cases-trigger">
                  <div className="app_section double" id="slide1"></div>
                  <div className="app_section slide_in" id="slide2-in"></div>
                  <div className="app_section double" id="slide2"></div>
                  <div className="app_section slide_in" id="slide3-in"></div>
                  <div className="app_section double" id="slide3"></div>
                  <div className="app_section slide_in" id="slide4-in"></div>
                  <div className="app_section double" id="slide4"></div>
                </div>
                <div className="app_section long" id="servicesTrigger"></div>
                <div className="app_section" id="services-in"></div>
                <div className="app_section products_runway" id="products-in"></div>
                <div
                  className="app_section double f a-c j-c"
                  id="productsTrigger"
                >
                  <div className="app_section" id="product-2"></div>
                </div>
                <div className="app_section" id="products-end"></div>
                <div className="app_section" id="story-in"></div>
                <div className="app_section long" id="storyTrigger"></div>
                <div className="app_section" id="contact-in"></div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}
